// extracted by mini-css-extract-plugin
export var active = "styles-module--active--1TXAB";
export var backButton = "styles-module--back-button--HhVfV";
export var backButtonLabel = "styles-module--back-button-label--nFWtK";
export var backButtonLogoContainer = "styles-module--back-button-logo-container--zPnQJ";
export var bold = "styles-module--bold--JIbF+";
export var brandLogoContainer = "styles-module--brand-logo-container--FEm-m";
export var brandLogoPlaceholder = "styles-module--brand-logo-placeholder--pi9Qc";
export var brandMetadataContainer = "styles-module--brand-metadata-container--hb-kK";
export var brandName = "styles-module--brand-name--P5BBO";
export var categoryName = "styles-module--category-name--OlpB3";
export var lockLogoContainer = "styles-module--lock-logo-container--klugP";
export var locked = "styles-module--locked--pQEpm";
export var menu = "styles-module--menu--jdy30";
export var menuItemLabel = "styles-module--menuItemLabel--v+9uL";
export var menuList = "styles-module--menu-list--oKw4m";
export var sideBarModal = "styles-module--side-bar-modal--2xg4W";
export var sideBarModalContent = "styles-module--side-bar-modal-content--LQ5KE";
export var sideBarModalHeader = "styles-module--side-bar-modal-header--LRl2x";